import React, { Component } from 'react';
import './ContextMenu.css'

class SmallNotification extends Component {
    // constructor(props) {
    //     super(props)
    // } 

    onClick=()=>{
        this.props.getSelectedEvent(this.props.eventInfo.Event_SysID)
    }
  
    render() {
        let ContextMenuStyle = {
            position:"fixed",
            left: this.props.pos.x,
            top:this.props.pos.y,
            width:450,
            backgroundColor:"#ffffff",
            border:"1px solid #797979",
            fontSize:"12px",
            padding:"5px",
            zIndex:1400,
            cursor:"pointer"
        }

        let dataRow = {
            display:"flex",
            flexDirection:"row"
        }

        let fieldTitle = {
            width:"25%",
        }

        let fieldValue = {
            width:"25%",
            color: "#0000ff"
        }

        return(
            <div style={ContextMenuStyle} onClick={this.onClick}>
                <div style={dataRow}>
                    <div style={fieldTitle}>專題系統編號</div><div style={fieldValue}>{this.props.eventInfo.Event_SysID}</div><div style={fieldTitle}>專題標題</div><div style={fieldValue}>{this.props.eventInfo.Event_Title}</div>
                </div>
                <div style={dataRow}>
                    <div style={fieldTitle}>專題刊登起始日期</div><div style={fieldValue}>{this.props.eventInfo.Event_StartDate.toDateString()}</div><div style={fieldTitle}>專題刊登結束日期</div><div style={fieldValue}>{this.props.eventInfo.Event_EndDate.toDateString()}</div> 
                </div>
               
            </div>
        )
    };
}

export default SmallNotification